import * as React from 'react';
import {observer} from 'mobx-react';
import {classes, style} from 'typestyle';
import {centerCenter, content} from 'csstips';
import {percent, px} from 'csx';

export interface PageHomeCTASeparatorProps {
  className?: string;
}

export const PageHomeCTASeparator = observer<PageHomeCTASeparatorProps>(
  ({ className }) => (
    <div className={classes(styles.container, className)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="1574" height="58" viewBox="0 0 1574 58">
        <path fill="none" fillRule="evenodd" stroke="#E0E5E9" d="M0 36.072C2.395 36.072 136.59 1 310.336 1c183.371 0 381.203 70.955 572.37 50.745C1426.682-5.765 1574 57 1574 57" opacity=".4"/>
        <path fill="none" fillRule="evenodd" stroke="#E0E5E9" d="M1574 21.928c-2.395 0-136.59 35.072-310.336 35.072-183.371 0-381.203-70.955-572.37-50.745C147.318 63.765 0 1 0 1"/>
      </svg>
    </div>
  )
);

const styles = {
  container: style({
    ...centerCenter,
    ...content,
    overflow: 'hidden',
    height: px(60),
    width: percent(100),
    $nest: {
      '&> svg': {
        overflow: 'visible'
      }
    }
  })
}